// src/api/suggestionApi.js
import apiClient from './axios';

const suggestionApi = {
  // getAll: async (page = 1, pageSize = 10, search = '') => {
  //   const response = await apiClient.get('/suggestions/', {
  //     params: { page, page_size: pageSize, search },
  //   });
  //   return response.data; // { data: [...], pagination: { ... } }
  // },

  
getAll: async (page = 1, pageSize = 10, search = '', employee = null) => {
  const params = { page, page_size: pageSize, search };
  
  // Add employee filter if provided
  if (employee && employee !== 'all') {
    params.employee = employee;
  }
  
  const response = await apiClient.get('/suggestions/', { params });
  return response.data;
},

  create: async (data) => {
    const response = await apiClient.post('/suggestions/', data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await apiClient.patch(`/suggestions/${id}/`, data);
    return response.data;
  },

  delete: async (id) => {
    await apiClient.delete(`/suggestions/${id}/`);
    return id;
  },

  markAsRead: async (id) => {
    const response = await apiClient.post(`/suggestions/${id}/mark_as_read/`);
    return response.data;
  },
};

export default suggestionApi;